import React from 'react'
import { Box, HStack, Text } from '@chakra-ui/react'

type GameZoneNoticeProps = {
  children: React.ReactNode
}

export const GameZoneNotice: React.FC<GameZoneNoticeProps> = ({ children }) => (
  <HStack align="center" spacing={3} px={4} py={3} bg="ninja.500" borderRadius="12px">
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      boxSize="18px"
      flexShrink={0}
      color="ninja.100"
      border="1px solid"
      borderColor="ninja.300"
      borderRadius="full"
      fontSize="11px"
      fontWeight={700}
      lineHeight={1}
    >
      i
    </Box>
    <Text color="brand.yellow" fontSize="12px" fontWeight={500} lineHeight={1.45}>
      {children}
    </Text>
  </HStack>
)
